module.exports = __webpack_public_path__ + "static/media/locked-stamp.8b3261a5.svg";